define('mustache-language/lib/Tokenizer',['require','exports','module'],function(require,exports,module){
    var RE_TOKEN = /(\{\{([^\}\{]+)\}\})/g,
        RE_TRIM  = /^(\s*)(.*?)(\s*)$/,
        OPEN = "{{",
        CLOSE= "}}",
        EMPTY = "";


    function Tokenizer(original){

        var tokens=this.tokens = [],
            trimmed = this.trimmed = [],
            key;

        this.original = original;
        key=(original + EMPTY).replace(RE_TRIM,function($0,$1,$2,$3){
            trimmed[0]=$1||'';
            trimmed[1]=$3||'';
            return $2;
        }).replace(RE_TOKEN,function($0,$1,$2){
            if($1){
                return OPEN+tokens.push($1)+CLOSE;
            }
            return $1
        });
        this.capitalized = key[0];
        this.key = key;
        this.lowerKey = key.toLowerCase();
    };

    Tokenizer.prototype.replace = function(translated, values){
        var tokens=values && values.length ? values : this.tokens,
            trimmed = this.trimmed;

        if(translated){
            return trimmed[0] + translated.replace(RE_TOKEN,function($0,$1,$2){
                return (tokens[$2-1]+"") || $1;
            }) + trimmed[1];
        }
        return this.original;
    };

    // Tokenizer.prototype.matchCase = function(){
    //     var original = this.original,
    //         first = original.charAt(0);
    //     if(first === first.toUpperCase() && (parseInt() )
    // }

    return Tokenizer;
});

